import React, { useState } from 'react'
import { Card, Col, Flex, Row } from 'antd'
import { JobAppliedTable, JobTable, ModuleTopHeading } from '../../components';


const Jobspage = () => {

    const [ visible, setVisible] = useState(false)
    
   
    return (
        <>
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading 
                                level={4} 
                                name='Jobs'
                                onClick={()=>setVisible(true)}
                            />
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <JobTable 
                            setVisible={setVisible}
                            visible={visible}
                        />
                    </Col>
                </Row>
            </Card>
            <JobAppliedTable />
        </>
    )
}

export { Jobspage }
